import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import { formatMoney } from '../../utils/formatMoney';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { setShowShoppingCart } from '../../redux/modules/show';
import './styles/product.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setShowShoppingCart: show => dispatch(setShowShoppingCart(show))
  };
}

function ConnectedProductComponent(props) {

  const { match } = props;
  const id = match.params.id;

  const [product, setProduct] = useState(null);
  const [selectedSlide, setSelectedSlide] = useState(null);
  const [selectedVariantId, setSelectedVariantId] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [amount, setAmount] = useState(0);

  const fetchData = async () => {
    const resp = await fetch(`${apiUrl}/products/get/${id}`);
    const json = await resp.json();

    if (json.success) {
      const { product } = json;

      setSelectedSlide(<img className="selectedSlideImage" src={product.thumbnail} />);
      setProduct(product);

      if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];

        setSelectedVariantId(firstVariant.id);
        setSelectedVariant(firstVariant);
        setAmount(product.hasDelivery ? firstVariant.price : firstVariant.price + product.deliveryPrice);
      } else {
        setAmount(product.hasDelivery ? product.price : product.price + product.deliveryPrice);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleSelectVariant = event => {
    setSelectedVariantId(event.target.value);

    const variant = product.variants.find(item => item.id === parseInt(event.target.value));
    setSelectedVariant(variant);
    setAmount(product.hasDelivery ? variant.price : variant.price + product.deliveryPrice);
  };

  const handleAddToCart = async () => {
    const { userId, token } = props;

    const prom = await fetch(`${apiUrl}/shoppingCart/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName,
        productId: product._id,
        amount,
        variant: selectedVariant
      })
    });

    const json = await prom.json();

    if (json.success) props.setShowShoppingCart(true);

  };

  if (!product || !props.token) {
    return (
      <div className="product-component">
        <Container>
          <AppSpinner />
        </Container>
      </div>
    );
  }

  const photosArr = product.photos || [];
  const settings = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: product.photos.length <= 4 ? product.photos.length : 4,
    slidesToScroll: 3
  };

  return (
    <div className="product-component">
      <Container>
        <Row>
          <Col lg={6}>
            <div className="selectedSlideContainer">{selectedSlide}</div>
            <div className="sliderContainer">
              <Slider {...settings}>
                {
                  photosArr.map((photo, i) =>
                    <div key={i} onClick={() => setSelectedSlide(
                      <img className="selectedSlideImage" src={photo} alt="Foto del programa" />
                    )}>
                      <img className="carouselImage" src={photo} alt="Miniatura de foto del producto" />
                    </div>
                  )
                }
              </Slider>
            </div>
          </Col>
          <Col lg={6}>
            <h1>
              {product.name}
            </h1>
            <p className="benefit-discount-price">
              ${formatMoney(amount)} COP
            </p>
            <h6>
              Envíos: {product.countryShipment ? 'Nivel nacional' : `${product.shipmentCities.map(item => item.label).join(', ')}.`}
            </h6>
            <p className="benefit-description">
              {product.description}
            </p>
            {
              product.details &&
              <>
                <h6>Detalles</h6>
                <p className="benefit-description">
                  {product.details}
                </p>
              </>
            }
            {
              (product.variants && product.variants.length > 0) &&
              <>
                <h6>Opciones</h6>
                <Row>
                  <Form.Group as={Col} md={6}>
                    {/* <Form.Label className="app-label">¿Este producto cuenta con inventario limitado?</Form.Label> */}
                    <Form.Control
                      as="select"
                      value={selectedVariantId}
                      onChange={handleSelectVariant}
                    >
                      {
                        product.variants.map(item => 
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      }
                    </Form.Control>
                  </Form.Group>
                  {
                    (selectedVariant && selectedVariant.details) &&
                    <Col xs={12}>
                      <h6></h6>
                      <p className="benefit-description">
                        <strong>Detalles de esta opción:</strong> {selectedVariant.details}
                      </p>
                    </Col>
                  }
                </Row>
              </>
            }
            <Button className="benefit-add-to-cart" onClick={handleAddToCart}>
              <i className="fas fa-cart-plus" /> Añadir al carrito
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const ProductComponent = connect(select, mapDispatchToProps)(ConnectedProductComponent);

export default ProductComponent;
